import * as mutation from "./mutation-types";

export const state = getInitialState();

export function getInitialState() {
  return {
    dashboard: {
      toggledLevyComponentsWidget: true,
      toggledProviderLevyAmountsWidget: false
    },
    create: {
      originalLevyCollectionId: null,
      sandboxLevyCollectionId: null,
      saving: false,
      error: {
        show: false,
        details: {},
        hideMutation: mutation.STATE_HIDE_ERROR,
        hideArgument: "create"
      }
    },
    delete: {
      levyCollectionId: null,
      processing: false
    },
    original: {
      loaded: false,
      loading: false,
      levyCollectionId: null,
      riskFactors: {},
      fees: {},
      levyCollection: {}
    }
  };
}

export function getUnloadedState() {
  return {
    original: { loaded: false }
  };
}
